import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";

// ─── Bug 5 Fix: Global error handler for unhandled promise rejections ───
window.addEventListener("unhandledrejection", (event) => {
  console.error("Unhandled promise rejection:", event.reason);
  // Prevent silent failures — show a non-intrusive toast if sonner is available
  const toastContainer = document.querySelector("[data-sonner-toaster]");
  if (toastContainer) {
    // Dynamically import to avoid circular deps
    import("sonner").then(({ toast }) => {
      toast.error("Something went wrong", {
        description: "An unexpected error occurred. Please try again.",
        duration: 5000,
      });
    }).catch(() => {});
  }
});

createRoot(document.getElementById("root")!).render(<App />);
